import React, { useState } from "react";
import "../../styles/components/TrustedCompanies.css";

import Modal from "../../components/Modal";
import ContactFormSimple from "../../components/ContactFormSimple";

import arrowCircle from "../../img/hero/arrow-circle-2.png";

import statIcon1 from "../../img/companies/stat-icon-1.png";
import statIcon2 from "../../img/companies/stat-icon-2.png";
import statIcon3 from "../../img/companies/stat-icon-3.png";

import trustImage from "../../img/companies/trust-visual.webp";

export default function TrustedStatsCard() {
  const [openModal, setOpenModal] = useState(false);

  return (
    <section className="tc tc--stats-card">
      <div className="tc__card tc-anim">
        <div className="tc__visual tc-card-anim__visual">
          <img
            className="tc__image tc-card-anim__image"
            src={trustImage}
            alt=""
            aria-hidden="true"
          />

          <span className="tc__floating tc__floating--1 tc-card-anim__float-1">
            <img src={statIcon1} alt="" aria-hidden="true" />
          </span>

          <span className="tc__floating tc__floating--2 tc-card-anim__float-2">
            <img src={statIcon2} alt="" aria-hidden="true" />
          </span>

          <span className="tc__floating tc__floating--3 tc-card-anim__float-3">
            <img src={statIcon3} alt="" aria-hidden="true" />
          </span>

          <button className="tc__cta" onClick={() => setOpenModal(true)}>
            <span>Start Your Project</span>
            <img src={arrowCircle} alt="" aria-hidden="true" />
          </button>
        </div>

        <div className="tc__stats tc-card-anim__stats">
          <div className="tc__stat">
            <div className="tc__number">20+</div>
            <div className="tc__line tc__line--1"></div>
            <div className="tc__label">clients</div>
          </div>

          <div className="tc__stat">
            <div className="tc__number">30+</div>
            <div className="tc__line tc__line--2"></div>
            <div className="tc__label">AI projects delivered</div>
          </div>

          <div className="tc__stat tc__stat--last">
            <div className="tc__number">$20m+</div>
            <div className="tc__line tc__line--3"></div>
            <div className="tc__label">client value generated</div>
          </div>
        </div>
      </div>

      <Modal open={openModal} onClose={() => setOpenModal(false)} title="Start your project">
        <ContactFormSimple onSubmit={() => setOpenModal(false)} />
      </Modal>
    </section>
  );
}
